import { z } from "zod";

/** Mirrors `apps/api` create/update Zod caps. */
export const API_NAME_MIN = 1;
export const API_WORKSPACE_NAME_MIN = 3;
export const API_NAME_MAX = 250;
export const API_DESCRIPTION_MAX = 1000;
export const API_TIME_NAME_MAX = 250;
export const API_CREDIT_DESCRIPTION_MAX = 255;
export const API_EMPLOYMENT_MIN = new Date(Date.UTC(2000, 0, 1));

export const API_HEX_COLOR_3_TO_6 = /^#[0-9A-Fa-f]{3,6}$/;
export const API_HEX_COLOR_6 = /^#[0-9A-Fa-f]{6}$/;
export const API_UUID_FORMAT = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const API_EMAIL_REGEX =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|([^-]([a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}))$/;

export const apiEntityNameSchema = z.string().trim().min(API_NAME_MIN).max(API_NAME_MAX);

export const apiWorkspaceNameSchema = z.string().trim().min(API_WORKSPACE_NAME_MIN).max(API_NAME_MAX);

export const apiDescriptionSchema = z.string().max(API_DESCRIPTION_MAX);

export const apiTimeNameSchema = z.string().max(API_TIME_NAME_MAX);

export const apiUuidFormatSchema = z.string().regex(API_UUID_FORMAT, "Invalid UUID format");

export const apiProjectColorSchema = z.string().trim().regex(API_HEX_COLOR_3_TO_6, "invalid-color").or(z.literal(""));

export const apiClientColorSchema = z.string().trim().regex(API_HEX_COLOR_6, "invalid-color").or(z.literal(""));

export const apiEmailSchema = z
	.string()
	.trim()
	.toLowerCase()
	.refine((value) => API_EMAIL_REGEX.test(value), "invalid-email");
